import { useState } from 'react';
import C from '../../colors';

function Field({ label, caption, error, helperText, children, last }) {
  return (
    <div style={{ padding: '18px 0', borderBottom: last ? 'none' : `1px solid ${C.hair}` }}>
      <div style={{ fontSize: 14, fontWeight: 500, color: C.ink, marginBottom: 3 }}>{label}</div>
      {caption && <div style={{ fontSize: 12.5, color: C.ink3, lineHeight: 1.5, marginBottom: 10 }}>{caption}</div>}
      <div style={{ marginTop: 10 }}>{children}</div>
      {error && <div style={{ fontSize: 12, color: '#c2412e', marginTop: 5 }}>{error}</div>}
      {helperText && !error && <div style={{ fontSize: 12, color: C.ink3, marginTop: 5 }}>{helperText}</div>}
    </div>
  );
}

function TextInput({ name, value, onChange, placeholder, error, prefix, suffix }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center',
      width: name === 'name' ? '100%' : 240,
      maxWidth: '100%',
      border: `1px solid ${error ? '#e88c7c' : focused ? C.brand : C.hair2}`,
      borderRadius: 6,
      background: '#fff',
      transition: 'border-color .15s',
    }}>
      {prefix && <span style={{ paddingLeft: 12, color: C.ink3, fontSize: 14 }}>{prefix}</span>}
      <input name={name} value={value ?? ''} onChange={onChange} placeholder={placeholder}
        onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        style={{
          minWidth: 0, flex: 1, padding: '9px 12px',
          border: 'none', outline: 'none',
          fontFamily: C.sans, fontSize: 14, background: 'transparent', color: C.ink,
          fontVariantNumeric: name === 'name' ? undefined : 'tabular-nums',
        }}/>
      {suffix && <span style={{ paddingRight: 12, color: C.ink3, fontSize: 14 }}>{suffix}</span>}
    </div>
  );
}

export default function PackageForm({ formId, handleSubmit, name, setName, photoCount, setPhotoCount, price, setPrice }) {
  const [nameError, setNameError] = useState(false);
  const [photoCountError, setPhotoCountError] = useState(false);
  const [priceError, setPriceError] = useState(false);

  const isNum = (v) => /^(0|[1-9][0-9]*)$/.test(v);
  const validateName = (v) => !v ? '套餐名不能为空' : '';
  const validatePhotoCount = (v) => {
    if (!v) return '可选照片数量不能为空';
    if (!isNum(v)) return '可选照片数量必须为数字';
    if (v > 1000) return '可选照片数量必须小于1000';
    return '';
  };
  const validatePrice = (v) => {
    if (!v) return '价格不能为空';
    if (!isNum(v)) return '价格必须为数字';
    if (v > 100000) return '价格必须小于100000';
    return '';
  };

  const handleInputChange = (event) => {
    let { name: fieldName, value } = event.target;
    value = value.trim();
    if (fieldName === 'name') { setName(value); setNameError(validateName(value)); }
    else if (fieldName === 'photoCount') { setPhotoCount(value); setPhotoCountError(validatePhotoCount(value)); }
    else if (fieldName === 'price') { setPrice(value); setPriceError(validatePrice(value)); }
  };

  const validateForm = (event) => {
    event.preventDefault();
    const ne = validateName(name);
    const pe = validatePhotoCount(photoCount);
    const re = validatePrice(price);
    setNameError(ne); setPhotoCountError(pe); setPriceError(re);
    if (ne || pe || re) return;
    handleSubmit(event);
  };

  return (
    <form id={formId} onSubmit={validateForm} style={{ width: '100%', maxWidth: 640 }}>
      <Field label="套餐名" caption="显示在创建订单时的套餐选择列表中。" error={nameError}>
        <TextInput name="name" value={name} onChange={handleInputChange} placeholder="套餐名" error={!!nameError}/>
      </Field>

      <Field label="可选照片数量" caption="客户在该套餐下最多可选择的照片数量。" error={photoCountError}>
        <TextInput name="photoCount" value={photoCount} onChange={handleInputChange} placeholder="可选照片数量" suffix="张" error={!!photoCountError}/>
      </Field>

      <Field label="价格" caption="套餐基础价格，用于内部统计和客户订单配置。" error={priceError} last>
        <TextInput name="price" value={price} onChange={handleInputChange} placeholder="价格" prefix="¥" error={!!priceError}/>
      </Field>
    </form>
  );
}
